<template>
    <div class="LiftWrapper">
        <div class="sliderWrapper">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    intensity
                </label>
                <div class="flex-1">
                    <input type="range" @input="setIntensity" :value="intensity" min="1" max="100" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{intensity}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
name:"LiftEffect",
data(){
    return{
        intensity:"50"
    }
},
computed:{
        getObjProperties(){
            return this.$store.getters.getActiveObjectprops
        },
       
    },
    watch:{
        getObjProperties :{
          handler(updatedValues) {
            
            this.intensity = updatedValues.effectType.intensity;
         
                
            },
            deep: true,
            immediate: true
        }
    },
methods:{
    setIntensity(e){
        this.intensity = e.target.value;
        this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.Lift() });
    },
    Lift(){
            
            let obj = {
              type:"lift",
                intensity:this.intensity
            };
  
              return obj
          },
}
}
</script>